import React, { FC } from "react";

import MaterialListItem, { ListItemProps } from "@mui/material/ListItem";

export const ListItem: FC<ListItemProps> = (props) => (
  <MaterialListItem {...props}>
    {props.children}
  </MaterialListItem>
);
